export default class RequestError {
  constructor(status, responseText, options, xhr) {
    this.status = status;
    this.responseText = responseText;
    this.options = options;
    this.xhr = xhr;
    try {
      this.response = JSON.parse(responseText ?? 'null');
    } catch (e) {
      this.response = null;
    }
    this.alert = null;
  }
}
flarum.reg.add('core', 'common/utils/RequestError', RequestError);